var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"page-main information-center"},[_c('section',{staticClass:"page-heading-wrap"},[_c('h3',{staticClass:"page-heading"},[_vm._v(_vm._s(_vm.$t('informationCenter.head')))])]),(_vm.$i18n.locale === 'ko')?_c('tab',{ref:"tab",staticClass:"tab-is-scroll",attrs:{"tab-list":_vm.tabList}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }